var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRejectWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15128 5.25626C5.61991 4.78763 6.3797 4.78763 6.84833 5.25626L11.9998 10.4077L17.1513 5.25626C17.6199 4.78763 18.3797 4.78763 18.8483 5.25626C19.317 5.72489 19.317 6.48468 18.8483 6.95331L13.6969 12.1048L18.8483 17.2563C19.317 17.7249 19.317 18.4847 18.8483 18.9533C18.3797 19.4219 17.6199 19.4219 17.1513 18.9533L11.9998 13.8018L6.84833 18.9533C6.3797 19.4219 5.61991 19.4219 5.15128 18.9533C4.68265 18.4847 4.68265 17.7249 5.15128 17.2563L10.3027 12.1048L5.15128 6.95331C4.68265 6.48468 4.68265 5.72489 5.15128 5.25626Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectWhiteIcon);
export default __webpack_public_path__ + "static/media/reject-white-icon.209f74365bee74e6fad1cde5e44fa3e6.svg";
export { ForwardRef as ReactComponent };